import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addUserrole,
  getUserroles,
  getUserrole,
  editUserrole,
  deleteUserrole,
  getAllUserroles,
} from "../../store/actions/userrole_action";
import { SEARCH_TERMS } from "../enums/userroles_enum";
// Get All Data
export const useAllUserroles = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.userrole);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      const params = new URLSearchParams(window.location.search);

      const paramsObj = Array.from(params.keys()).reduce(
        (acc, val) => ({ ...acc, [val]: params.get(val) }),
        {}
      );
      let newQParams = ``;
      Object.keys(paramsObj) &&
        Object.keys(paramsObj).map((item, index) => {
          if (item.includes("_select")) {
            if (item.split("_select") && item.split("_select")[0]) {
              newQParams += `&select[${item.split("_select")[0]}]=${
                paramsObj[item]
              }`;
            }
          } else {
            newQParams += `&exact[${item}]=${paramsObj[item]}`;
          }
        });
      if (deleteEntry) {
        await dispatch(deleteUserrole(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getUserroles({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
            queryParams: newQParams,
          })
        );
      } else {
        dispatch(
          getUserroles({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
            queryParams: newQParams,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo, window.location.search]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getUserroles({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleUserrole = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.userrole);
  useEffect(() => {
    dispatch(getUserrole(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateUserrole = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addUserrole(data));
  };
  return [addData];
};
export const useUpdateUserrole = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editUserrole(id, data));
  };
  return [updateData];
};

export const useSelectAllUserrole = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.userrole);
  useEffect(() => {
    dispatch(getAllUserroles({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};
